export default "__VITE_ASSET__D5ygDfGH__"